import React from "react";
import styles from "./services.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCode, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import LazyText from "../../common/imagescroll/LazyText";

const Services: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className={styles.sectionWrapper}>

            {/* CENTERED TITLES INSIDE SECTION */}
            <LazyText>
                <h1 className={styles.section_title}>
                    {String(t("homePage.ourServices"))}
                </h1>
            </LazyText>

            <LazyText>
                <h2 className={styles.services_message}>
                    {String(t("homePage.servicesMessage"))}
                </h2>
            </LazyText>

            {/* YOUR GRID — UNTOUCHED */}
            <div className={styles.gridContainer}>
                <div className={styles.card}>
                    <div className={styles.card_title}>
                        {String(t("homePage.webAppService"))}
                    </div>
                    <div className={styles.icon_container}>
                        <FontAwesomeIcon icon={faLaptop} />
                    </div>
                    <div className={styles.content}>
                        <p>
                            Custom web apps built for your business goals,
                            Scalable, secure, and built to grow,
                            Fast performance with smooth user experience,
                            Smart solutions that boost efficiency and results.
                        </p>
                    </div>
                    <p
                        className={styles.learn_more}
                        onClick={() => (window.location.href = "/services/web-applications")}
                    >
                        Learn More <FontAwesomeIcon icon={faArrowRight} />
                    </p>
                </div>

                <div className={styles.card}>
                    <div className={styles.card_title}>
                        {String(t("homePage.responsiveDesignService"))}
                    </div>
                    <div className={styles.icon_container}>
                        <FontAwesomeIcon icon={faCode} />
                    </div>
                    <div className={styles.content}>
                        <p>
                            Mobile-friendly websites for any screen,
                            Clean, intuitive UI/UX for better usability,
                            Fully responsive designs that perform smoothly,
                            Optimized to improve search rankings and engagement.
                        </p>
                    </div>
                    <p
                        className={styles.learn_more}
                        onClick={() => (window.location.href = "/services/web-design")}
                    >
                        Learn More <FontAwesomeIcon icon={faArrowRight} />
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Services;
